<template>
  <div class="scheduletop">
    <tab-navigation-panel :tabs="tabs" />
    <router-view />
  </div>
</template>

<script>
import TabNavigationPanel from "@/components/TabNavigationPanel.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "scheduletop-view",
  components: { TabNavigationPanel },
  data: () => ({
    tabs: [
      { label: "Kalender", name: "Schedule" },
      { label: "Simulering", name: "Disposition", override: false, overrideStyle:"background-color:rgb(216,180,82); transition: .3s background-color ease-in 0s;" },
    ],

  }),
  async mounted() {
    await this.getHolidays();
  },
  methods: {
    ...mapActions("holidayStore", ["getHolidays"]),
  },
  computed: {
    ...mapGetters('groupTemplateStore', ['isGroupTemplateSimulating']),
  },
  watch: {
    'isGroupTemplateSimulating'(newValue) {
      this.tabs.find(q => q.name === "Disposition").override = newValue;
    }
  }
}
</script>
